import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { RUN_ID_PARAM_NAME } from 'src/common/services/queries/CommonParams';

import { TMfaSessionIssuesFilterOptions } from '../../../MfaDashboardServiceTypes';
import { MfaSessionScansQueryVariables } from '../MfaSessionScans.generated';

const SCAN_ID_FILTER_PARAM_NAME = 'scanIdFilter';

export interface IGetMfaSessionScansParams {
	sessionId: string;
	filterOptions?: TMfaSessionIssuesFilterOptions;
}

export const buildMfaSessionScansVariables = (
	params: IGetMfaSessionScansParams
): MfaSessionScansQueryVariables => {
	const { sessionId, filterOptions } = params;
	const variablesBuilder = new QueryVariablesBuilder<MfaSessionScansQueryVariables>({});

	return variablesBuilder
		.addConditionParam(RUN_ID_PARAM_NAME, sessionId)
		.addFilterParam(SCAN_ID_FILTER_PARAM_NAME, filterOptions?.scans)
		.getVariables();
};
